export default ($axios) => ({
    $axios,

    async fetch({
        type,
        filters,
        sort,
        tags,
    }) {
        return await $axios.get(`/${type}?limit=100&${filters}${sort}${tags}`)
    },

    async fetchById({
        type,
        id,
    }) {
        return await $axios.get(`/${type}/${id}`)
    },

    async comments({
        type,
        id,
    }) {
        return await $axios.get(`/${type}/${id}/comments_ratings`)
    },

    async fetchTimesheets({
        type,
        query,
    }) {
        return await $axios.get(`/${type}/daily-calendar${query}`)
    },

    async createTimesheets({
        type,
        id,
    }, form) {
        return await $axios.post(`/${type}/${id}/timesheets`, form)
    },

    async fetchByPhone(query) {
        return await $axios.get(`/masters${query}`)
    },

    async fetchBadges(id) {
        return await $axios.get(`/masters/${id}/badges`)
    },

    async saveBadges(id, form) {
        return await $axios.post(`/masters/${id}/badges`, form)
    },

    async uploadImage(id, form) {
        return await $axios.post(`/masters/${id}/image`, form)
    },

    async fetchMap({
        type,
    }) {
        return await $axios.get(`/${type}/map`)
    },

    async fetchMapById({
        id,
        type,
        query = '',
    }) {
        return await $axios.get(`/${type}/${id}/map${query}`)
    },

    async requestForDelete({
        type,
        id,
    }) {
        return await $axios.post(`/${type}/${id}/markToRemove`)
    },

    async sendMail(form) {
        return await $axios.post('/mail/send', form)
    },

    async schedule({
        year,
        month,
        id,
    }) {
        return await $axios.get(
            `/schedule/masters/${id}?year=${year}&month=${month}`,
        )
    },

    async addSchedule(form) {
        return await $axios.post('/schedule/masters', form)
    },

    async addScheduleById(form) {
        return await $axios.post('/schedule/masters/day', {
            master_id: form.master_id,
            date: form.date,
            time: {
                from: form.from,
                to: form.to,
            },
        })
    },

    async removeSchedule(id) {
        return await $axios.delete(`schedule/masters/schedule/${id}`)
    },

    async removeScheduleAll({
        id,
        year,
        month,
    }) {
        return await $axios.delete(`/schedule/masters/${id}?year=${year}&month=${month}`)
    },

    async updateSchedule({
        id,
        from,
        to,
    }) {
        return await $axios.put(`/schedule/masters/schedule/${id}`, {
            time_from: from,
            time_to: to,
        })
    },

    async getSkills(id) {
        return await $axios.get(`/skills?master_id=${id}`)
    },

    async addSkills(id, form) {
        return await $axios.post(`/masters/${id}/skills`, form)
    },

    async getTools(id) {
        return await $axios.get(`/instruments?master_id=${id}`)
    },

    async addTools(id, form) {
        return await $axios.post(`/masters/${id}/instruments`, form)
    },

    async fetchRecommendedMasters(form) {
        return await $axios.post('/recommended', form)
    },
})
